// AURA HOME - Header Dropdown Enhancements
(function () {
  function init() {
    var headerMenu = document.querySelector('header-menu');
    if (!headerMenu) { setTimeout(init, 500); return; }

    var detailsElements = headerMenu.querySelectorAll('details');
    detailsElements.forEach(function (details) {
      var summary = details.querySelector('summary, .menu-list__link, a[href]');
      if (summary) {
        summary.addEventListener('click', function () {
          setTimeout(function () {
            var anyOpen = headerMenu.querySelector('details[open]');
            headerMenu.setAttribute('aria-expanded', anyOpen ? 'true' : 'false');
            if (anyOpen && anyOpen !== details) {
              detailsElements.forEach(function (other) {
                if (other !== details && other.hasAttribute('open')) { other.removeAttribute('open'); }
              });
            }
          }, 0);
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('header-menu')) {
        var opened = headerMenu.querySelectorAll('details[open]');
        if (opened.length > 0) {
          opened.forEach(function (d) { d.removeAttribute('open'); });
          headerMenu.setAttribute('aria-expanded', 'false');
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var opened = headerMenu.querySelectorAll('details[open]');
        if (opened.length > 0) {
          opened.forEach(function (d) { d.removeAttribute('open'); });
          headerMenu.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();